'use strict';

angular.module('lmsApp').factory('Topic', function ($resource) {
    return $resource('api/topics/:id', {}, {
        'query': {
            method: 'GET',
            isArray: true
        },
        'get': {
            method: 'GET',
            transformResponse: function (data) {
                data = angular.fromJson(data);
                return data;
            }
        },
        'update': {
            method: 'PUT'
        },
        'delete': {
            method: 'DELETE'
        },
        'add': {
            method: 'POST'
        }
    });
});
